define('app/components/ractivejs.play',[

    'ractive',
    'plugins/ractive/ractive.adaptor.backbone',

    'app/app.utils',

    'lodash'

  ],
  function (
    Ractive,
    RactiveAdaptorBackbone,
    UTILS,
    _
  ) {

    var LOG_LABEL = 'RACTIVEJS BASE'

    Ractive.DEBUG = !!window.SE.IS_DEBUG

    var components = {},
      templateHelper_$fn = {
        is: function (valA, valB) {
          valB = valB === undefined ? true : valB // compare by default with 'true'
          return _.isEqual(valA, valB)
        },
        in: function (val, inVal) {
          if (!inVal) return false
          if (typeof inVal == 'string')
            inVal = inVal.split('|')

          //console.debug("IN?", val, inVal)

          return inVal.indexOf(val) >= 0
        },
        excerpt: function (val, max_length, separator) {
          max_length = max_length || 32
          separator = separator !== undefined ? separator : /\W/

          val = typeof val === 'undefined' ? '' : val

          // remove possibly wrapping quotes
          val = val.replace(/^["']/, '').replace(/["']$/, '')

          var $sdom = $('<div/>').shadowhtml(val || '')
          val = ($sdom.text().trim() || $sdom.shadowhtml().trim())

          if (val.length <= max_length + 2) return val

          return _.trunc(val, { length: max_length, separator: separator })
        },
        size: function (obj) {
          return obj ? _.size(obj) : 0
        },
        dump: function (val) {

          return val ? JSON.stringify(val) : val

        },
        getTime: function (timestampms) {
          return (new Date(timestampms)).toTimeString().substr(0, 8)
        }
      },
      decorators = {
        /**
         * observer for input fields -> onchange calls Ractive.update() to keep the value in the
         * form fields and the model (forced) in sync
         *
         * @param node
         * @param content
         * @returns {{teardown: Function}}
         */
        obs: function (node, content) {
          var ta

          var dataKeyPath = $(node).attr('data-obs-path')

          if (!dataKeyPath && $(node).closest('[data-obs-path]').size()) {
            dataKeyPath = $(node).closest('[data-obs-path]').attr('data-obs-path')
          }
          if ($(node).is('textarea')) {
            $(node).autosize()
          }

          var onChange = function (ev) {

            console.debug(LOG_LABEL, 'obs', 'change', dataKeyPath, ev)

            //if (dataKeyPath) {
            //    _this.update(dataKeyPath);
            //} else {
            //    //_this.update();
            //}

          }

          $(node).on('change', onChange)

          return {
            teardown: function () {
              $(node)
                .off('change', onChange)
                .autosize('destroy')

              return
            }
          }
        },

        /**
         * multi decorator
         * use: <div decorator="d:'decorator1','decorator2:param1,param2'>...</div>
         * @param node
         * @returns {{teardown: Function}}
         */
        d: function (node) {
          var _that = this,
            tmpDecorator, tmpDecoFn, tmpArgs,
            teardownFns = []

          if (!_that.decorators) {
            console.error(LOG_LABEL, 'no decorators set', _that)
          }

          _.forEach(arguments, function (decoFn, i) {
            if (i > 0) {
              tmpDecorator = decoFn.split(':')
              tmpDecoFn = tmpDecorator[0]
              tmpArgs = tmpDecorator[1] ? tmpDecorator[1].split(',') : []
              tmpArgs.unshift(node)

              if (!_that.decorators[tmpDecoFn]) {
                console.error(LOG_LABEL, 'decorator not found', tmpDecoFn, _that.decorators)

              } else {
                teardownFns.push(_that.decorators[tmpDecoFn].apply(_that, tmpArgs))

              }
            }
          })
          return {
            teardown: function () {
              _.forEach(teardownFns, function (teardownObj) {
                teardownObj.teardown()
              })
            }
          }
        }
      },
      transitions = {},
      events = {
        change: function (node, fire) {
          var oldVal,
            int0

          function getValue () {
            var newVal = node.value || node.dataset.value

            if (node.checked === false) {
              switch (node.getAttribute('type').toLowerCase()) {
                case 'radio':
                  newVal = undefined
                  break
                case 'checkbox':
                  newVal = null
                  break
              }
            } else if (node.selected === false) {
              newVal = undefined
            }

            return newVal
          }

          function changeHandler (event) {
            var newVal = getValue()

            if (newVal === oldVal) return

            fire({
              node: node,
              original: event,
              newVal: newVal,
              oldVal: oldVal,
              valName: node.name || node.dataset.name
            })

            oldVal = newVal
          }

          node.addEventListener('change', changeHandler)

          int0 = setInterval(function () {
            if (getValue() !== oldVal) {
              UTILS.dispatchCustomEvent(node, 'change')
            }
          }, 24)

          return {
            teardown: function () {
              node.removeEventListener('change', changeHandler)
              clearInterval(int0)
            }
          }
        }
      }

    return Ractive.extend({
      data: function () {
        return {
          $fn: templateHelper_$fn
        }
      },
      adapt: [RactiveAdaptorBackbone],
      decorators: decorators,
      components: components,
      transitions: transitions,
      events: events
    })

  });
